import { Context } from "./Reducers/Store";
import React, { useContext } from "react";
import { useLocation, Navigate } from "react-router-dom";

function RequireAuth({ children }) {
    const [state] = useContext(Context);
    let location = useLocation();

    if (!state.isLogged) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
}

export default RequireAuth;
